export interface RelationshipCharacterInput {
  id?: string
  name: string
  profile?: string
  personality?: string
  background?: string
}

export interface RequiredRelationship {
  name: string
  relationship: string
  description?: string
}

export interface RelationshipInput {
  mainCharacter?: RelationshipCharacterInput
  secondCharacter?: RelationshipCharacterInput
  additionalCharacters?: RelationshipCharacterInput[]  // 複数キャラクター対応
  savedCharacterIds?: string[]
  characterText?: string
  characterFile?: string
  numberOfCharacters: number  // 1〜15の範囲
  requiredRelationships?: RequiredRelationship[]
  complexityLevel?: number
  worldContext?: string  // 世界観のコンテキスト
  additionalSettings?: string  // 追加設定（任意）
  seed?: number
  useProMode?: boolean
  useGemini3FlashMode?: boolean // Gemini 3 Flashモード（試験版）
  mode?: 'detailed' | 'image'  // 詳細モード or イメージモード
}

export interface CharacterNode {
  id: string
  name: string
  profile: string
  personality?: string
  background?: string
  isMain?: boolean
}

export interface RelationshipEdge {
  source: string
  target: string
  relationshipType?: string  // 後方互換性のため残す
  sourceToTargetType?: string  // 新しいフィールド
  targetToSourceType?: string  // 新しいフィールド
  fromSourceToTarget: string
  fromTargetToSource: string
  strength: number
  description?: string
}

export interface RelationshipResult {
  characters: CharacterNode[]
  relationships: RelationshipEdge[]
  summary: string
}

export interface SavedRelationship {
  id: string
  title: string
  input: RelationshipInput
  result: RelationshipResult
  createdAt: string
  updatedAt: string
  memo?: string
  tags?: string[]
}

export type RelationshipType = 
  | 'friend'
  | 'lover'
  | 'family'
  | 'rival'
  | 'mentor'
  | 'colleague'
  | 'enemy'
  | 'acquaintance'
  | 'partner'
  | 'subordinate'
  | 'superior'
  | 'childhood_friend'
  | 'ex_lover'
  | 'admirer'
  | 'other'

export const RELATIONSHIP_TYPE_LABELS: Record<RelationshipType, string> = {
  friend: '友人',
  lover: '恋人',
  family: '家族',
  rival: 'ライバル',
  mentor: '師匠',
  colleague: '同僚',
  enemy: '敵',
  acquaintance: '知人',
  partner: 'パートナー',
  subordinate: '部下',
  superior: '上司',
  childhood_friend: '幼馴染',
  ex_lover: '元恋人',
  admirer: '憧れの人',
  other: 'その他'
}

export const RELATIONSHIP_TYPE_COLORS: Record<RelationshipType, string> = {
  friend: '#22c55e',       // 明るい緑（友好的）
  lover: '#ec4899',        // ピンク（恋愛）
  family: '#3b82f6',       // 青（家族）
  rival: '#f97316',        // 濃いオレンジ（競争）
  mentor: '#8b5cf6',       // 紫（師弟）
  colleague: '#9ca3af',    // 中間グレー（仕事・その他）
  enemy: '#7c2d12',        // 濃い茶色（敵対・見分けやすい）
  acquaintance: '#9ca3af', // 中間グレー（仕事・その他）
  partner: '#06b6d4',      // シアン（パートナー・幼馴染）
  subordinate: '#9ca3af',  // 中間グレー（仕事・その他）
  superior: '#9ca3af',     // 中間グレー（仕事・その他）
  childhood_friend: '#06b6d4', // シアン（パートナー・幼馴染）
  ex_lover: '#ec4899',     // ピンク（恋愛）
  admirer: '#fbbf24',      // 黄色（憧れ）
  other: '#9ca3af'         // 中間グレー（仕事・その他）
}